import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/Logo/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Footer/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Header/Header.tsx");
